// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#TVFuturesChartContainer,
#TVFuturesChartContainerMobile {
  height: 100%;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
}

#TVFuturesChartContainer > *,
#TVFuturesChartContainerMobile > * {
  width: 100%;
}

#TVFuturesChartContainerMobile iframe {
  border-radius: 10px;
  height: 594px;
}

@media (max-width: 480px) {
  #TVFuturesChartContainerMobile iframe {
    height: 404px;
  }
}

.mobile-spot-container-light #TVFuturesChartContainerMobile {
  background-color: #fff !important;
}

.mobile-spot-container-dark #TVFuturesChartContainerMobile {
  background-color: #000 !important;
}

.trade-wrapper-mobile {
  padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/Libraries/FuturesChartContainer/index.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["#TVFuturesChartContainer,\n#TVFuturesChartContainerMobile {\n  height: 100%;\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n#TVFuturesChartContainer > *,\n#TVFuturesChartContainerMobile > * {\n  width: 100%;\n}\n\n#TVFuturesChartContainerMobile iframe {\n  border-radius: 10px;\n  height: 594px;\n}\n\n@media (max-width: 480px) {\n  #TVFuturesChartContainerMobile iframe {\n    height: 404px;\n  }\n}\n\n.mobile-spot-container-light #TVFuturesChartContainerMobile {\n  background-color: #fff !important;\n}\n\n.mobile-spot-container-dark #TVFuturesChartContainerMobile {\n  background-color: #000 !important;\n}\n\n.trade-wrapper-mobile {\n  padding: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
